/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Case_Additional_Vehicles_CountInputs */

const en_case_additional_vehicles_count = /** @type {(inputs: Case_Additional_Vehicles_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const pt_br2_case_additional_vehicles_count = /** @type {(inputs: Case_Additional_Vehicles_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

/**
* | output |
* | --- |
* | "+{count}" |
*
* @param {Case_Additional_Vehicles_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_additional_vehicles_count = /** @type {((inputs: Case_Additional_Vehicles_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Additional_Vehicles_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_additional_vehicles_count(inputs)
	return pt_br2_case_additional_vehicles_count(inputs)
});